import { Component, OnInit, ChangeDetectionStrategy } from '@angular/core';
import { UntypedFormGroup, Validators, FormsModule, ReactiveFormsModule } from '@angular/forms';
import { ActivatedRoute, Router } from '@angular/router';

import { Observable } from 'rxjs';

import { ExerciseService } from '../../exercise.service';
import { UtilitiesService } from '../../../../shared/utilities.service';
import {FormService} from '../../../../core/services/form.service';
import { ExerciseModel, ProblemModel, TopicModel } from '@generativ/much-smarter-models';
import { ContentViewerComponent } from '../../../../shared/content-viewer/content-viewer.component';

@Component({
    selector: 'app-lesson-strategy-hypothesis',
    templateUrl: './exercise-strategy-hypothesis.component.html',
    styleUrls: ['../exercise-strategy.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    imports: [ContentViewerComponent, FormsModule, ReactiveFormsModule]
})
export class ExerciseStrategyHypothesisComponent implements OnInit {

  strategyTopics: TopicModel[];
  strategyProblem: ProblemModel;

  hypothesisForm: UntypedFormGroup;

  constructor(private router: Router,
              private activatedRoute: ActivatedRoute,
              private utilitiesService: UtilitiesService,
              public formService: FormService,
              private exerciseService: ExerciseService) {
    this.hypothesisForm = this.formService.createForm(this.formOptions);
  }

  ngOnInit() {
    this.strategyProblem = this.exerciseService.getStrategyProblem();
    this.strategyTopics = this.exerciseService.getStrategyTopics();
  }

  handleOnSubmit() {
    if (this.formService.validateFormAndUpdateErrors(this.hypothesisForm)) {
      this.router.navigate([`../answer`], {relativeTo: this.activatedRoute});
    }
  }

  private get formOptions(): Record<string, unknown> {
    return {
      hypothesis: [
        null,
        Validators.compose( [
          Validators.required
        ])
      ]
    };
  }

}
